import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

export const useAutoFunds = ({ onSuccess, onSaveAutoFunding, currencyCode }) => {
  const [errors, setErrors] = useAsyncSafeState();

  const updateAutoFundsConfig = useCallback(
    async (_autofundEnabled, _balanceThreshold, _autofundAmount, _maxDailyFundings) => {
      setErrors(null);

      const config = {
        threshold: !_autofundEnabled ? null : { value: Number(_balanceThreshold), code: currencyCode },
        amount: !_autofundEnabled ? null : { value: Number(_autofundAmount), code: currencyCode },
        cutoff: !_autofundEnabled ? null : Number(_maxDailyFundings),
      };

      try {
        await onSaveAutoFunding(config);
        onSuccess(config);
      } catch (e) {
        setErrors(e?.response?.data?.Errors ?? [{}]);
      }
    },
    [setErrors, onSaveAutoFunding, onSuccess, currencyCode],
  );

  return {
    errors,
    updateAutoFundsConfig,
  };
};
